// extracted by mini-css-extract-plugin
export var actions = "_id-d";
export var benefitCard = "_id-a";
export var benefitIcon = "_id-b";
export var benefitLabel = "_id-c";
export var benefits = "_id-9";
export var bodyText = "_id-8";
export var closeButton = "_id-2";
export var content = "_id-3";
export var eyebrow = "_id-4";
export var heading = "_id-5";
export var image = "_id-f";
export var imagePanel = "_id-e";
export var modal = "_id-0";
export var shell = "_id-1";
export var title = "_id-6";
export var titleOffer = "_id-7";